const _excluded = ["catalog"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22;
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import { action, computed, makeObservable, observable, runInAction, toJS, when } from "mobx";
import { createTransformer } from "mobx-utils";
import Clock from "terriajs-cesium/Source/Core/Clock";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import CesiumEvent from "terriajs-cesium/Source/Core/Event";
import RequestScheduler from "terriajs-cesium/Source/Core/RequestScheduler";
import RuntimeError from "terriajs-cesium/Source/Core/RuntimeError";
import buildModuleUrl from "terriajs-cesium/Source/Core/buildModuleUrl";
import defined from "terriajs-cesium/Source/Core/defined";
import queryToObject from "terriajs-cesium/Source/Core/queryToObject";
import SplitDirection from "terriajs-cesium/Source/Scene/SplitDirection";
import URI from "urijs";
import { Category, DataSourceAction, LaunchAction } from "../Core/AnalyticEvents/analyticEvents";
import AsyncLoader from "../Core/AsyncLoader";
import ConsoleAnalytics from "../Core/ConsoleAnalytics";
import CorsProxy from "../Core/CorsProxy";
import GoogleAnalytics from "../Core/GoogleAnalytics";
import { isJsonBoolean, isJsonNumber, isJsonObject, isJsonString } from "../Core/Json";
import { isLatLonHeight } from "../Core/LatLonHeight";
import Result from "../Core/Result";
import ServerConfig from "../Core/ServerConfig";
import TerriaError, { TerriaErrorSeverity } from "../Core/TerriaError";
import ensureSuffix from "../Core/ensureSuffix";
import filterOutUndefined from "../Core/filterOutUndefined";
import getDereferencedIfExists from "../Core/getDereferencedIfExists";
import getPath from "../Core/getPath";
import hashEntity from "../Core/hashEntity";
import instanceOf from "../Core/instanceOf";
import isDefined from "../Core/isDefined";
import loadJson from "../Core/loadJson";
import loadJson5 from "../Core/loadJson5";
import { getUriWithoutPath } from "../Core/uriHelpers";
import { featureBelongsToCatalogItem, isProviderCoordsMap } from "../Map/PickedFeatures/PickedFeatures";
import CatalogMemberMixin, { getName } from "../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../ModelMixins/GroupMixin";
import MappableMixin, { isDataSource } from "../ModelMixins/MappableMixin";
import ReferenceMixin from "../ModelMixins/ReferenceMixin";
import NotificationState from "../ReactViewModels/NotificationState";
import { defaultTerms } from "../ReactViewModels/defaultTerms";
import { SHARE_VERSION } from "../ReactViews/Map/Panels/SharePanel/BuildShareLink";
import { shareConvertNotification } from "../ReactViews/Notification/shareConvertNotification";
import MappableTraits from "../Traits/TraitsClasses/MappableTraits";
import MapNavigationModel from "../ViewModels/MapNavigation/MapNavigationModel";
import TerriaViewer from "../ViewModels/TerriaViewer";
import { BaseMapsModel } from "./BaseMaps/BaseMapsModel";
import CameraView from "./CameraView";
import Catalog from "./Catalog/Catalog";
import CatalogGroup from "./Catalog/CatalogGroup";
import CatalogMemberFactory from "./Catalog/CatalogMemberFactory";
import MagdaReference from "./Catalog/CatalogReferences/MagdaReference";
import SplitItemReference from "./Catalog/CatalogReferences/SplitItemReference";
import CommonStrata from "./Definition/CommonStrata";
import { BaseModel } from "./Definition/Model";
import hasTraits from "./Definition/hasTraits";
import updateModelFromJson from "./Definition/updateModelFromJson";
import upsertModelFromJson from "./Definition/upsertModelFromJson";
import StubErrorServiceProvider from "./ErrorServiceProviders/StubErrorServiceProvider";
import TerriaFeature from "./Feature/Feature";
import { isInitFromData, isInitFromDataPromise, isInitFromOptions, isInitFromUrl } from "./InitSource";
import Internationalization from "./Internationalization";
import NoViewer from "./NoViewer";
import CatalogIndex from "./SearchProviders/CatalogIndex";
import { SearchBarModel } from "./SearchProviders/SearchBarModel";
import TimelineStack from "./TimelineStack";
import { isViewerMode, setViewerMode } from "./ViewerMode";
import Workbench from "./Workbench";
let Terria = (_class = class Terria {
  get baseMapContrastColor() {
    var _this$baseMapsModel$b, _this$baseMapsModel$b2;
    return (_this$baseMapsModel$b = (_this$baseMapsModel$b2 = this.baseMapsModel.baseMapItems.find(basemap => {
      var _basemap$item, _basemap$item2, _this$mainViewer$base;
      return isDefined((_basemap$item = basemap.item) === null || _basemap$item === void 0 ? void 0 : _basemap$item.uniqueId) && ((_basemap$item2 = basemap.item) === null || _basemap$item2 === void 0 ? void 0 : _basemap$item2.uniqueId) === ((_this$mainViewer$base = this.mainViewer.baseMap) === null || _this$mainViewer$base === void 0 ? void 0 : _this$mainViewer$base.uniqueId);
    })) === null || _this$baseMapsModel$b2 === void 0 ? void 0 : _this$baseMapsModel$b2.contrastColor) !== null && _this$baseMapsModel$b !== void 0 ? _this$baseMapsModel$b : "#ffffff";
  }
  get previewedItemId() {
    return this._previewedItemId;
  }

  /**
   * Base ratio for maximumScreenSpaceError
   * @type {number}
   */

  constructor() {
    var _options$cesiumBaseUr;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _defineProperty(this, "models", observable.map());
    /** Map from share key -> id */
    _defineProperty(this, "shareKeysMap", observable.map());
    /** Map from id -> share keys */
    _defineProperty(this, "modelIdShareKeysMap", observable.map());
    /** Base URL for the Terria app. Used for SPA routes */
    _defineProperty(this, "appBaseHref", ensureSuffix(typeof document !== "undefined" ? document.baseURI : "/", "/"));
    /** Base URL to Terria resources */
    _defineProperty(this, "baseUrl", "build/TerriaJS/");
    /**
     * Base URL used by Cesium to link to images and other static assets.
     * This can be customized by passing `options.cesiumBaseUrl`
     * Default value is constructed relative to `Terria.baseUrl`.
     */
    _defineProperty(this, "cesiumBaseUrl", void 0);
    _defineProperty(this, "tileLoadProgressEvent", new CesiumEvent());
    _defineProperty(this, "indeterminateTileLoadProgressEvent", new CesiumEvent());
    _defineProperty(this, "workbench", new Workbench());
    _defineProperty(this, "overlays", new Workbench());
    _defineProperty(this, "catalog", new Catalog(this));
    _defineProperty(this, "baseMapsModel", new BaseMapsModel("basemaps", this));
    _defineProperty(this, "searchBarModel", new SearchBarModel(this));
    _defineProperty(this, "timelineClock", new Clock({
      shouldAnimate: false
    }));
    // readonly overrides: any = overrides; // TODO: add options.functionOverrides like in master
    _defineProperty(this, "catalogIndex", void 0);
    _defineProperty(this, "elements", observable.map());
    _initializerDefineProperty(this, "mainViewer", _descriptor, this);
    _defineProperty(this, "appName", "TerriaJS App");
    _defineProperty(this, "supportEmail", "info@terria.io");
    /**
     * Gets or sets the {@link this.corsProxy} used to determine if a URL needs to be proxied and to proxy it if necessary.
     * @type {CorsProxy}
     */
    _defineProperty(this, "corsProxy", new CorsProxy());
    /**
     * Gets or sets the instance to which to report Google Analytics-style log events.
     * If a global `ga` function is defined, this defaults to `GoogleAnalytics`.  Otherwise, it defaults
     * to `ConsoleAnalytics`.
     */
    _defineProperty(this, "analytics", void 0);
    /**
     * Gets the stack of layers active on the timeline.
     */
    _defineProperty(this, "timelineStack", new TimelineStack(this, this.timelineClock));
    _initializerDefineProperty(this, "configParameters", _descriptor2, this);
    _initializerDefineProperty(this, "pickedFeatures", _descriptor3, this);
    _initializerDefineProperty(this, "selectedFeature", _descriptor4, this);
    _initializerDefineProperty(this, "allowFeatureInfoRequests", _descriptor5, this);
    /**
     * Gets or sets the stack of map interactions modes.  The mode at the top of the stack
     * (highest index) handles click interactions with the map
     */
    _initializerDefineProperty(this, "mapInteractionModeStack", _descriptor6, this);
    _initializerDefineProperty(this, "isWorkflowPanelActive", _descriptor7, this);
    /** Gets or sets the active SelectableDimensionWorkflow, if defined, then the workflow will be displayed using `WorkflowPanel` */
    _initializerDefineProperty(this, "selectableDimensionWorkflow", _descriptor8, this);
    /**
     * Flag for zooming to workbench items after all init sources have been loaded.
     *
     * This is automatically enabled when your init file has the following settings:
     * ```
     *    {"initialCamera": {"focusWorkbenchItems": true}}
     * ```
     */
    _defineProperty(this, "focusWorkbenchItemsAfterLoadingInitSources", false);
    _defineProperty(this, "_loadPersistedSettings", {
      baseMapPromise: undefined
    });
    _initializerDefineProperty(this, "userProperties", _descriptor9, this);
    _initializerDefineProperty(this, "initSources", _descriptor0, this);
    _defineProperty(this, "_initSourceLoader", new AsyncLoader(this.forceLoadInitSources.bind(this)));
    _initializerDefineProperty(this, "serverConfig", _descriptor1, this);
    // TODO
    _initializerDefineProperty(this, "shareDataService", _descriptor10, this);
    /* Splitter controls */
    _initializerDefineProperty(this, "showSplitter", _descriptor11, this);
    _initializerDefineProperty(this, "splitPosition", _descriptor12, this);
    _initializerDefineProperty(this, "splitPositionVertical", _descriptor13, this);
    _initializerDefineProperty(this, "terrainSplitDirection", _descriptor14, this);
    _initializerDefineProperty(this, "depthTestAgainstTerrainEnabled", _descriptor15, this);
    _initializerDefineProperty(this, "stories", _descriptor16, this);
    _initializerDefineProperty(this, "storyPromptShown", _descriptor17, this);
    // Story Prompt modal will be rendered when this property changes. See StandardUserInterface, section regarding sui.notifications. Ideally move this to ViewState.
    /**
     * Gets or sets the ID of the catalog member that is currently being
     * previewed. This is observed in ViewState. It is used to open "Add data" if a catalog member is open in a share link.
     * This should stay private - use viewState.viewCatalogMember() instead
     */
    _initializerDefineProperty(this, "_previewedItemId", _descriptor18, this);
    _initializerDefineProperty(this, "baseMaximumScreenSpaceError", _descriptor19, this);
    /**
     * Model to use for map navigation
     */
    _initializerDefineProperty(this, "mapNavigationModel", _descriptor20, this);
    /**
     * Gets or sets whether to use the device's native resolution (sets cesium.viewer.resolutionScale to a ratio of devicePixelRatio)
     * @type {boolean}
     */
    _initializerDefineProperty(this, "useNativeResolution", _descriptor21, this);
    /**
     * Whether we think all references in the catalog have been loaded
     * @type {boolean}
     */
    _initializerDefineProperty(this, "catalogReferencesLoaded", _descriptor22, this);
    _defineProperty(this, "augmentedVirtuality", void 0);
    _defineProperty(this, "notificationState", new NotificationState());
    _defineProperty(this, "developmentEnv", process.env.NODE_ENV === "development");
    /**
     * An error service instance. The instance can be provided via the
     * `errorService` startOption. Here we initialize it to stub provider so
     * that the `terria.errorService` always exists.
     */
    _defineProperty(this, "errorService", new StubErrorServiceProvider());
    /**
     * @experimental
     */
    _defineProperty(this, "catalogProvider", void 0);
    makeObservable(this);
    if (options.appBaseHref) {
      this.appBaseHref = ensureSuffix(typeof document !== "undefined" ? new URI(options.appBaseHref).absoluteTo(document.baseURI).toString() : options.appBaseHref, "/");
    }
    if (options.baseUrl) {
      this.baseUrl = ensureSuffix(options.baseUrl, "/");
    }

    // Try to construct an absolute URL to send to Cesium, as otherwise it resolves relative
    // to document.location instead of the correct document.baseURI
    // This URL can still be relative if Terria is running in an environment without `document`
    // (e.g. Node.js) and no absolute URL is passed as an option for `appBaseHref`. In this case,
    // send a relative URL to cesium
    const cesiumBaseUrlRelative = (_options$cesiumBaseUr = options.cesiumBaseUrl) !== null && _options$cesiumBaseUr !== void 0 ? _options$cesiumBaseUr : "".concat(this.baseUrl, "build/Cesium/build/");
    this.cesiumBaseUrl = ensureSuffix(new URI(cesiumBaseUrlRelative).absoluteTo(this.appBaseHref).toString(), "/");
    // Casting to `any` as `setBaseUrl` method is not part of the Cesiums' type definitions
    buildModuleUrl.setBaseUrl(this.cesiumBaseUrl);
    this.analytics = options.analytics;
    if (!defined(this.analytics)) {
      if (typeof window !== "undefined" && defined(window.ga)) {
        this.analytics = new GoogleAnalytics();
      } else {
        this.analytics = new ConsoleAnalytics();
      }
    }
  }

  /** Raise error to user.
   *
   * This accepts same arguments as `TerriaError.from` - but also has:
   *
   * @param forceRaiseToUser - which can be used to force raise the error
   */
  raiseErrorToUser(error, overrides) {
    let forceRaiseToUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const terriaError = TerriaError.from(error, overrides);

    // Set shouldRaiseToUser true if forceRaiseToUser agrument is true
    if (forceRaiseToUser) terriaError.overrideRaiseToUser = true;

    // Log error to error service
    this.errorService.error(terriaError);

    // Only show error to user if `ignoreError` flag hasn't been set to "1"
    // Note: this will take precedence over forceRaiseToUser/overrideRaiseToUser
    if (this.userProperties.get("ignoreErrors") !== "1") this.notificationState.addNotificationToQueue(terriaError.toNotification());
    terriaError.log();
  }
  get currentViewer() {
    return this.mainViewer.currentViewer;
  }
  get cesium() {
    if (isDefined(this.mainViewer) && this.mainViewer.currentViewer.type === "Cesium") {
      return this.mainViewer.currentViewer;
    }
  }

  /**
   * @returns The currently active `TerrainProvider` or `undefined`.
   */
  get terrainProvider() {
    var _this$cesium;
    return (_this$cesium = this.cesium) === null || _this$cesium === void 0 ? void 0 : _this$cesium.terrainProvider;
  }
  get leaflet() {
    if (isDefined(this.mainViewer) && this.mainViewer.currentViewer.type === "Leaflet") {
      return this.mainViewer.currentViewer;
    }
  }
  get modelValues() {
    return Array.from(this.models.values());
  }
  get modelIds() {
    return Array.from(this.models.keys());
  }
  getModelById(type, id) {
    const model = this.models.get(id);
    if (instanceOf(type, model)) {
      return model;
    }

    // Model does not have the requested type.
    return undefined;
  }
  addModel(model, shareKeys) {
    if (model.uniqueId === undefined) {
      throw new DeveloperError("A model without a `uniqueId` cannot be added.");
    }
    if (this.models.has(model.uniqueId)) {
      throw new RuntimeError("A model with the specified ID already exists: `".concat(model.uniqueId, "`"));
    }
    this.models.set(model.uniqueId, model);
    shareKeys === null || shareKeys === void 0 || shareKeys.forEach(shareKey => this.addShareKey(model.uniqueId, shareKey));
  }

  /**
   * Remove references to a model from Terria.
   */
  removeModelReferences(model) {
    this.removeSelectedFeaturesForModel(model);
    this.workbench.remove(model);
    if (model.uniqueId) {
      this.models.delete(model.uniqueId);
    }
  }
  removeSelectedFeaturesForModel(model) {
    const pickedFeatures = this.pickedFeatures;
    if (pickedFeatures) {
      // Remove picked features that belong to the catalog item
      pickedFeatures.features.forEach((feature, i) => {
        if (featureBelongsToCatalogItem(feature, model)) {
          pickedFeatures === null || pickedFeatures === void 0 || pickedFeatures.features.splice(i, 1);
          if (this.selectedFeature === feature) this.selectedFeature = undefined;
        }
      });
    }
  }
  getModelIdByShareKey(shareKey) {
    return this.shareKeysMap.get(shareKey);
  }
  getModelByIdOrShareKey(type, id) {
    const model = this.getModelById(type, id);
    if (model) {
      return model;
    } else {
      const idFromShareKey = this.getModelIdByShareKey(id);
      return idFromShareKey !== undefined ? this.getModelById(type, idFromShareKey) : undefined;
    }
  }
  async getModelByIdShareKeyOrCatalogIndex(id) {
    try {
      // See if model exists by ID of sharekey
      const model = this.getModelByIdOrShareKey(BaseModel, id);
      // If no model exists, try to find it through Terria model sharekeys or CatalogIndex sharekeys
      if ((model === null || model === void 0 ? void 0 : model.uniqueId) !== undefined) {
        return new Result(model);
      } else if (this.catalogIndex) {
        try {
          await this.catalogIndex.load();
        } catch (e) {
          throw TerriaError.from(e, "Failed to load CatalogIndex while trying to load model `".concat(id, "`"));
        }
        const indexModel = this.catalogIndex.getModelByIdOrShareKey(id);
        if (indexModel) {
          (await indexModel.loadReference()).throwIfError();
          return new Result(indexModel.target);
        }
      }
    } catch (e) {
      return Result.error(e);
    }
    return new Result(undefined);
  }
  addShareKey(id, shareKey) {
    var _this$modelIdShareKey, _this$modelIdShareKey2;
    if (id === shareKey || this.shareKeysMap.has(shareKey)) return;
    this.shareKeysMap.set(shareKey, id);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    (_this$modelIdShareKey = (_this$modelIdShareKey2 = this.modelIdShareKeysMap.get(id)) === null || _this$modelIdShareKey2 === void 0 ? void 0 : _this$modelIdShareKey2.push(shareKey)) !== null && _this$modelIdShareKey !== void 0 ? _this$modelIdShareKey : this.modelIdShareKeysMap.set(id, [shareKey]);
  }
  setupInitializationUrls(baseUri, config) {
    const initializationUrls = (config === null || config === void 0 ? void 0 : config.initializationUrls) || [];
    const initSources = initializationUrls.map(url => _objectSpread({
      name: "Init URL from config ".concat(url),
      errorSeverity: TerriaErrorSeverity.Error
    }, generateInitializationUrl(baseUri, this.configParameters.initFragmentPaths, url)));

    // look for v7 catalogs -> push v7-v8 conversion to initSources
    if (Array.isArray(config === null || config === void 0 ? void 0 : config.v7initializationUrls)) {
      initSources.push(...config.v7initializationUrls.filter(isJsonString).map(v7initUrl => ({
        name: "V7 Init URL from config ".concat(v7initUrl),
        errorSeverity: TerriaErrorSeverity.Error,
        data: (async () => {
          try {
            const [{
              convertCatalog
            }, catalog] = await Promise.all([import("catalog-converter"), loadJson5(v7initUrl)]);
            const convert = convertCatalog(catalog, {
              generateIds: false
            });
            console.log("WARNING: ".concat(v7initUrl, " is a v7 catalog - it has been upgraded to v8\nMessages:\n"));
            convert.messages.forEach(message => console.log("- ".concat(message.path.join("."), ": ").concat(message.message)));
            return new Result({
              data: convert.result || {}
            });
          } catch (error) {
            return Result.error(error, {
              title: {
                key: "models.catalog.convertErrorTitle"
              },
              message: {
                key: "models.catalog.convertErrorMessage",
                parameters: {
                  url: v7initUrl
                }
              }
            });
          }
        })()
      })));
    }
    this.initSources.push(...initSources);
  }
  async start(options) {
    var _options$applicationU, _this$analytics, _this$analytics2;
    // Some hashProperties need to be set before anything else happens
    const hashProperties = queryToObject(new URI(window.location).fragment());
    if (isDefined(hashProperties["ignoreErrors"])) {
      this.userProperties.set("ignoreErrors", hashProperties["ignoreErrors"]);
    }
    this.shareDataService = options.shareDataService;

    // If in development environment, allow usage of #configUrl to set Terria config URL
    if (this.developmentEnv) {
      if (isDefined(hashProperties["configUrl"]) && hashProperties["configUrl"] !== "") options.configUrl = hashProperties["configUrl"];
    }
    const baseUri = new URI(options.configUrl).filename("");
    const launchUrlForAnalytics = ((_options$applicationU = options.applicationUrl) === null || _options$applicationU === void 0 ? void 0 : _options$applicationU.href) || getUriWithoutPath(baseUri);
    try {
      const config = await loadJson5(options.configUrl, options.configUrlHeaders);

      // If it's a magda config, we only load magda config and parameters should never be a property on the direct
      // config aspect (it would be under the `terria-config` aspect)
      if (isJsonObject(config) && config.aspects) {
        await this.loadMagdaConfig(options.configUrl, config, baseUri);
      }
      runInAction(() => {
        if (isJsonObject(config) && isJsonObject(config.parameters)) {
          this.updateParameters(config.parameters);
        }
        this.setupInitializationUrls(baseUri, config);
      });
    } catch (error) {
      this.raiseErrorToUser(error, {
        sender: this,
        title: {
          key: "models.terria.loadConfigErrorTitle"
        },
        message: "Couldn't load ".concat(options.configUrl),
        severity: TerriaErrorSeverity.Error
      });
    } finally {
      var _options$i18nOptions;
      if (!((_options$i18nOptions = options.i18nOptions) !== null && _options$i18nOptions !== void 0 && _options$i18nOptions.skipInit)) {
        await Internationalization.initLanguage(this.configParameters.languageConfiguration, options.i18nOptions, this.baseUrl);
      }
    }
    setCustomRequestSchedulerDomainLimits(this.configParameters.customRequestSchedulerLimits);
    if (options.errorService) {
      try {
        this.errorService = options.errorService;
        this.errorService.init(this.configParameters);
      } catch (e) {
        var _this$configParameter;
        console.error("Failed to initialize error service: ".concat((_this$configParameter = this.configParameters.errorService) === null || _this$configParameter === void 0 ? void 0 : _this$configParameter.provider), e);
      }
    }
    (_this$analytics = this.analytics) === null || _this$analytics === void 0 || _this$analytics.start(this.configParameters);
    (_this$analytics2 = this.analytics) === null || _this$analytics2 === void 0 || _this$analytics2.logEvent(Category.launch, LaunchAction.url, launchUrlForAnalytics);
    this.serverConfig = new ServerConfig();
    const serverConfig = await this.serverConfig.init(this.configParameters.serverConfigUrl);
    await this.initCorsProxy(this.configParameters, serverConfig);
    if (this.shareDataService && this.serverConfig.config) {
      this.shareDataService.init(this.serverConfig.config);
    }

    // Create catalog index if catalogIndexUrl is set
    // Note: this isn't loaded now, it is loaded in first CatalogSearchProvider.doSearch()
    if (this.configParameters.catalogIndexUrl && !this.catalogIndex) {
      this.catalogIndex = new CatalogIndex(this, this.configParameters.catalogIndexUrl);
    }
    this.baseMapsModel.initializeDefaultBaseMaps().catchError(error => this.raiseErrorToUser(TerriaError.from(error, "Failed to load default basemaps")));
    this.searchBarModel.updateModelConfig(this.configParameters.searchBarConfig).initializeSearchProviders(this.configParameters.searchProviders).catchError(error => this.raiseErrorToUser(TerriaError.from(error, "Failed to initialize searchProviders")));
    if (typeof options.beforeRestoreAppState === "function") {
      try {
        await options.beforeRestoreAppState();
      } catch (error) {
        console.log(error);
      }
    }
    await this.restoreAppState(options);
  }
  async restoreAppState(options) {
    if (options.applicationUrl) {
      (await this.updateApplicationUrl(options.applicationUrl.href)).raiseError(this);
    }
    this.loadPersistedMapSettings();
  }

  /**
   * Zoom to workbench items if `focusWorkbenchItemsAfterLoadingInitSources` is `true`.
   *
   * Note that the current behaviour is to zoom to the first item of the
   * workbench, however in the future we should modify it to zoom to a view
   * which shows all the workbench items.
   *
   * If a Cesium or Leaflet viewer is not available,
   * we wait for it to load before triggering the zoom.
   */
  async doZoomToWorkbenchItems() {
    if (!this.focusWorkbenchItemsAfterLoadingInitSources) {
      return;
    }

    // TODO: modify this to zoom to a view that shows all workbench items
    // instead of just zooming to the first workbench item!
    const firstMappableItem = this.workbench.items.find(item => MappableMixin.isMixedInto(item));
    if (firstMappableItem) {
      // When the app loads, Cesium/Leaflet viewers are loaded
      // asynchronously. Until they become available, a stub viewer called
      // `NoViewer` is used. `NoViewer` does not implement zooming to mappable
      // items. So here wait for a valid viewer to become available before
      // attempting to zoom to the mappable item.
      const isViewerAvailable = () => this.currentViewer.type !== NoViewer.type;
      // Note: In some situations the following use of when() can result in
      // a hanging promise if a valid viewer never becomes available,
      // for eg: when react is not rendered - `currentViewer` will always be `NoViewer`.
      await when(isViewerAvailable);
      await this.currentViewer.zoomTo(firstMappableItem, 0.0);
    }
  }
  loadPersistedMapSettings() {
    var _this$getLocalPropert;
    const persistViewerMode = this.configParameters.persistViewerMode;
    const hashViewerMode = this.userProperties.get("map");
    if (hashViewerMode && isViewerMode(hashViewerMode)) {
      setViewerMode(hashViewerMode, this.mainViewer);
    } else if (persistViewerMode) {
      const viewerMode = this.getLocalProperty("viewermode");
      if (isDefined(viewerMode) && isViewerMode(viewerMode)) {
        setViewerMode(viewerMode, this.mainViewer);
      }
    }
    const useNativeResolution = this.getLocalProperty("useNativeResolution");
    if (typeof useNativeResolution === "boolean") {
      this.setUseNativeResolution(useNativeResolution);
    }
    const baseMaximumScreenSpaceError = parseFloat(((_this$getLocalPropert = this.getLocalProperty("baseMaximumScreenSpaceError")) === null || _this$getLocalPropert === void 0 ? void 0 : _this$getLocalPropert.toString()) || "");
    if (!isNaN(baseMaximumScreenSpaceError)) {
      this.setBaseMaximumScreenSpaceError(baseMaximumScreenSpaceError);
    }
  }
  setUseNativeResolution(useNativeResolution) {
    this.useNativeResolution = useNativeResolution;
  }
  setBaseMaximumScreenSpaceError(baseMaximumScreenSpaceError) {
    this.baseMaximumScreenSpaceError = baseMaximumScreenSpaceError;
  }
  async loadPersistedOrInitBaseMap() {
    var _baseMap;
    const baseMapItems = this.baseMapsModel.baseMapItems;
    // Set baseMap fallback to first option
    let baseMap = baseMapItems[0];
    const persistedBaseMapId = this.getLocalProperty("basemap");
    const baseMapSearch = baseMapItems.find(baseMapItem => {
      var _baseMapItem$item;
      return ((_baseMapItem$item = baseMapItem.item) === null || _baseMapItem$item === void 0 ? void 0 : _baseMapItem$item.uniqueId) === persistedBaseMapId;
    });
    if (baseMapSearch !== null && baseMapSearch !== void 0 && baseMapSearch.item && MappableMixin.isMixedInto(baseMapSearch.item)) {
      baseMap = baseMapSearch;
    } else {
      var _baseMapItems$find;
      // Try to find basemap using defaultBaseMapId and defaultBaseMapName
      const baseMapSearch = (_baseMapItems$find = baseMapItems.find(baseMapItem => {
        var _baseMapItem$item2;
        return ((_baseMapItem$item2 = baseMapItem.item) === null || _baseMapItem$item2 === void 0 ? void 0 : _baseMapItem$item2.uniqueId) === this.baseMapsModel.defaultBaseMapId;
      })) !== null && _baseMapItems$find !== void 0 ? _baseMapItems$find : baseMapItems.find(baseMapItem => CatalogMemberMixin.isMixedInto(baseMapItem) && baseMapItem.item.name === this.baseMapsModel.defaultBaseMapName);
      if (baseMapSearch !== null && baseMapSearch !== void 0 && baseMapSearch.item && MappableMixin.isMixedInto(baseMapSearch.item)) {
        baseMap = baseMapSearch;
      }
    }
    if ((_baseMap = baseMap) !== null && _baseMap !== void 0 && _baseMap.item) await this.mainViewer.setBaseMap(baseMap.item);
  }
  get isLoadingInitSources() {
    return this._initSourceLoader.isLoading;
  }

  /**
   * Asynchronously loads init sources
   */
  loadInitSources() {
    return this._initSourceLoader.load();
  }
  dispose() {
    this._initSourceLoader.dispose();
  }
  async updateFromStartData(startData) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Application start data";
    let /** Error severity to use for loading startData init sources - default will be `TerriaErrorSeverity.Error` */
    errorSeverity = arguments.length > 2 ? arguments[2] : undefined;
    try {
      await interpretStartData(this, startData, name, errorSeverity);
    } catch (e) {
      return Result.error(e);
    }
    return await this.loadInitSources();
  }
  async updateApplicationUrl(newUrl) {
    const uri = new URI(newUrl);
    const hash = uri.fragment();
    const hashProperties = queryToObject(hash);
    function checkSegments(urlSegments, customRoute) {
      // Accept /${customRoute}/:some-id/ or /${customRoute}/:some-id
      return (urlSegments.length === 3 && urlSegments[2] === "" || urlSegments.length === 2) && urlSegments[0] === customRoute && urlSegments[1].length > 0;
    }
    try {
      await interpretHash(this, hashProperties, this.userProperties, new URI(newUrl).filename("").query("").hash(""));

      // /catalog/ and /story/ routes
      if (newUrl.startsWith(this.appBaseHref)) {
        const pageUrl = new URL(newUrl);
        // Find relative path from baseURI to documentURI excluding query and hash
        // then split into url segments
        // e.g. "http://ci.terria.io/main/story/1#map=2d" -> ["story", "1"]
        const segments = (pageUrl.origin + pageUrl.pathname).slice(this.appBaseHref.length).split("/");
        if (checkSegments(segments, "catalog")) {
          this.initSources.push({
            name: "Go to ".concat(pageUrl.pathname),
            errorSeverity: TerriaErrorSeverity.Error,
            data: {
              previewedItemId: decodeURIComponent(segments[1])
            }
          });
          const replaceUrl = new URL(newUrl);
          replaceUrl.pathname = new URL(this.appBaseHref).pathname;
          history.replaceState({}, "", replaceUrl.href);
        } else if (checkSegments(segments, "story") && isDefined(this.configParameters.storyRouteUrlPrefix)) {
          let storyJson;
          try {
            storyJson = await loadJson("".concat(this.configParameters.storyRouteUrlPrefix).concat(segments[1]));
          } catch (e) {
            throw TerriaError.from(e, {
              message: "Failed to fetch story `\"".concat(this.appName, "/").concat(segments[1], "\"`")
            });
          }
          await interpretStartData(this, storyJson, "Start data from story `\"".concat(this.appName, "/").concat(segments[1], "\"`"));
          runInAction(() => this.userProperties.set("playStory", "1"));
        }
      }
    } catch (e) {
      this.raiseErrorToUser(e);
    }
    return await this.loadInitSources();
  }
  updateParameters(parameters) {
    var _this$configParameter2, _this$configParameter3;
    Object.entries(parameters).forEach(_ref2 => {
      let [key, value] = _ref2;
      if (Object.hasOwnProperty.call(this.configParameters, key)) {
        this.configParameters[key] = value;
      }
    });
    this.appName = (_this$configParameter2 = this.configParameters.appName) !== null && _this$configParameter2 !== void 0 ? _this$configParameter2 : this.appName;
    this.supportEmail = (_this$configParameter3 = this.configParameters.supportEmail) !== null && _this$configParameter3 !== void 0 ? _this$configParameter3 : this.supportEmail;
  }
  async forceLoadInitSources() {
    const loadInitSource = createTransformer(async initSource => {
      let initSourceData;
      if (isInitFromUrl(initSource)) {
        try {
          const json = await loadJson5(initSource.initUrl);
          if (isJsonObject(json, false)) {
            initSourceData = json;
          }
        } catch (e) {
          throw TerriaError.from(e, {
            message: {
              key: "models.terria.loadingInitJsonMessage",
              parameters: {
                url: initSource.initUrl
              }
            }
          });
        }
      } else if (isInitFromOptions(initSource)) {
        let error;
        for (const option of initSource.options) {
          try {
            initSourceData = await loadInitSource(option);
            if (initSourceData !== undefined) break;
          } catch (err) {
            error = err;
          }
        }
        if (initSourceData === undefined && error !== undefined) throw error;
      } else if (isInitFromData(initSource)) {
        initSourceData = initSource.data;
      } else if (isInitFromDataPromise(initSource)) {
        var _await$initSource$dat;
        initSourceData = (_await$initSource$dat = (await initSource.data).throwIfError()) === null || _await$initSource$dat === void 0 ? void 0 : _await$initSource$dat.data;
      }
      return initSourceData;
    });
    const errors = [];

    // Load all init sources
    // Converts them to InitSourceFromData
    const loadedInitSources = await Promise.all(this.initSources.map(async initSource => {
      try {
        return {
          name: initSource.name,
          errorSeverity: initSource.errorSeverity,
          data: await loadInitSource(initSource)
        };
      } catch (e) {
        var _initSource$name;
        errors.push(TerriaError.from(e, {
          severity: initSource.errorSeverity,
          message: {
            key: "models.terria.loadingInitSourceError2Message",
            parameters: {
              loadSource: (_initSource$name = initSource.name) !== null && _initSource$name !== void 0 ? _initSource$name : "Unknown source"
            }
          }
        }));
      }
    }));
    let baseMapPromise;
    // Sequentially apply all InitSources
    for (let i = 0; i < loadedInitSources.length; i++) {
      const initSource = loadedInitSources[i];
      if (!isDefined(initSource === null || initSource === void 0 ? void 0 : initSource.data)) continue;
      try {
        const result = await this._applyInitData({
          initData: initSource.data
        });
        if (result.baseMapPromise) {
          baseMapPromise = result.baseMapPromise;
        }
      } catch (e) {
        var _name;
        errors.push(TerriaError.from(e, {
          severity: initSource === null || initSource === void 0 ? void 0 : initSource.errorSeverity,
          message: {
            key: "models.terria.loadingInitSourceError2Message",
            parameters: {
              loadSource: (_name = initSource.name) !== null && _name !== void 0 ? _name : "Unknown source"
            }
          }
        }));
      }
    }

    // Wait for any basemap loaded from applyInitData to finish
    // loading before we restore from user preference.
    Promise.resolve(baseMapPromise).finally(() => {
      runInAction(() => {
        if (!this.mainViewer.baseMap) {
          // Note: there is no "await" here - as basemaps can take a while
          // to load and there is no need to wait for them to load before
          // rendering Terria
          this.loadPersistedOrInitBaseMap();
        }
      });
    });

    // Zoom to workbench items if any of the init sources specifically requested it
    if (this.focusWorkbenchItemsAfterLoadingInitSources) {
      this.doZoomToWorkbenchItems();
    }
    if (errors.length > 0) {
      // Note - this will get wrapped up in a Result object because it is called in AsyncLoader
      throw TerriaError.combine(errors, {
        title: {
          key: "models.terria.loadingInitSourcesErrorTitle"
        },
        message: {
          key: "models.terria.loadingInitSourcesErrorMessage",
          parameters: {
            appName: this.appName,
            email: this.supportEmail
          }
        }
      });
    }
  }
  async loadModelStratum(modelId, stratumId, allModelStratumData, replaceStratum) {
    const thisModelStratumData = allModelStratumData[modelId] || {};
    if (!isJsonObject(thisModelStratumData)) {
      throw new TerriaError({
        sender: this,
        title: "Invalid model traits",
        message: "The traits of a model must be a JSON object."
      });
    }
    const cleanStratumData = _objectSpread({}, thisModelStratumData);
    delete cleanStratumData.dereferenced;
    delete cleanStratumData.knownContainerUniqueIds;
    const errors = [];
    const containerIds = thisModelStratumData.knownContainerUniqueIds;
    if (Array.isArray(containerIds)) {
      // Groups that contain this item must be loaded before this item.
      await Promise.all(containerIds.map(async containerId => {
        if (typeof containerId !== "string") {
          return;
        }
        const container = (await this.loadModelStratum(containerId, stratumId, allModelStratumData, replaceStratum)).pushErrorTo(errors, "Failed to load container ".concat(containerId));
        if (container) {
          const dereferenced = ReferenceMixin.isMixedInto(container) ? container.target : container;
          if (GroupMixin.isMixedInto(dereferenced)) {
            (await dereferenced.loadMembers()).pushErrorTo(errors, "Failed to load group ".concat(dereferenced.uniqueId));
          }
        }
      }));
    }
    const model = (await this.getModelByIdShareKeyOrCatalogIndex(modelId)).pushErrorTo(errors);
    if ((model === null || model === void 0 ? void 0 : model.uniqueId) !== undefined) {
      // Update modelId from model sharekeys or CatalogIndex sharekeys
      modelId = model.uniqueId;
    }

    // If this model is a `SplitItemReference` we must load the source item first
    const splitSourceId = cleanStratumData.splitSourceItemId;
    if (cleanStratumData.type === SplitItemReference.type && typeof splitSourceId === "string") {
      (await this.loadModelStratum(splitSourceId, stratumId, allModelStratumData, replaceStratum)).pushErrorTo(errors, "Failed to load SplitItemReference ".concat(splitSourceId));
    }
    const loadedModel = upsertModelFromJson(CatalogMemberFactory, this, "/", stratumId, _objectSpread(_objectSpread({}, cleanStratumData), {}, {
      id: modelId
    }), {
      replaceStratum
    }).pushErrorTo(errors);
    if (loadedModel && Array.isArray(containerIds)) {
      containerIds.forEach(containerId => {
        if (typeof containerId === "string" && loadedModel.knownContainerUniqueIds.indexOf(containerId) < 0) {
          loadedModel.knownContainerUniqueIds.push(containerId);
        }
      });
    }
    // If we're replacing the stratum and the existing model is already
    // dereferenced, we need to replace the dereferenced stratum, too,
    // even if there's no trace of it in the load data.
    let dereferenced = isJsonObject(thisModelStratumData.dereferenced) ? thisModelStratumData.dereferenced : undefined;
    if (loadedModel && replaceStratum && dereferenced === undefined && ReferenceMixin.isMixedInto(loadedModel) && loadedModel.target !== undefined) {
      dereferenced = {};
    }
    if (loadedModel && ReferenceMixin.isMixedInto(loadedModel)) {
      (await loadedModel.loadReference()).pushErrorTo(errors, "Failed to load reference ".concat(loadedModel.uniqueId));
      if (isDefined(loadedModel.target)) {
        updateModelFromJson(loadedModel.target, stratumId, dereferenced || {}, replaceStratum).pushErrorTo(errors, "Failed to update model from JSON: ".concat(loadedModel.target.uniqueId));
      }
    } else if (dereferenced) {
      throw new TerriaError({
        sender: this,
        title: "Model cannot be dereferenced",
        message: "Model ".concat(getName(loadedModel), " has a `dereferenced` property, but the model cannot be dereferenced.")
      });
    }
    if (loadedModel) {
      const dereferencedGroup = getDereferencedIfExists(loadedModel);
      if (GroupMixin.isMixedInto(dereferencedGroup)) {
        if (dereferencedGroup.isOpen) {
          (await dereferencedGroup.loadMembers()).pushErrorTo(errors, "Failed to open group ".concat(dereferencedGroup.uniqueId));
        }
      }
    }
    return new Result(loadedModel, TerriaError.combine(errors, {
      // This will set TerriaErrorSeverity to Error if the model which FAILED to load is in the workbench.
      severity: () => this.workbench.items.find(workbenchItem => workbenchItem.uniqueId === modelId) ? TerriaErrorSeverity.Error : TerriaErrorSeverity.Warning,
      message: {
        key: "models.terria.loadModelErrorMessage",
        parameters: {
          model: modelId
        }
      }
    }));
  }
  async pushAndLoadMapItems(model, newItems, errors) {
    if (ReferenceMixin.isMixedInto(model)) {
      (await model.loadReference()).pushErrorTo(errors);
      if (model.target !== undefined) {
        await this.pushAndLoadMapItems(model.target, newItems, errors);
      } else {
        errors.push(TerriaError.from("Reference model has no target. Model Id: " + model.uniqueId));
      }
    } else if (GroupMixin.isMixedInto(model)) {
      (await model.loadMembers()).pushErrorTo(errors);
      model.memberModels.map(async m => {
        await this.pushAndLoadMapItems(m, newItems, errors);
      });
    } else if (MappableMixin.isMixedInto(model)) {
      newItems.push(model);
      (await model.loadMapItems()).pushErrorTo(errors);
    } else {
      errors.push(TerriaError.from("Can not load an un-mappable item to the map. Item Id: " + model.uniqueId));
    }
  }
  async applyInitData(params) {
    await this._applyInitData(params);
  }

  /**
   * @private
   */
  async _applyInitData(_ref3) {
    var _initData$settings;
    let {
      initData,
      replaceStratum = false,
      canUnsetFeaturePickingState = false
    } = _ref3;
    const errors = [];
    initData = toJS(initData);
    let baseMapPromise;
    const stratumId = typeof initData.stratum === "string" ? initData.stratum : CommonStrata.definition;

    // Extract the list of CORS-ready domains.
    if (Array.isArray(initData.corsDomains)) {
      this.corsProxy.corsDomains.push(...initData.corsDomains);
    }

    // Add catalog members
    if (initData.catalog !== undefined) {
      this.catalog.group.addMembersFromJson(stratumId, initData.catalog).pushErrorTo(errors);
    }

    // Show/hide elements in mapNavigationModel
    if (isJsonObject(initData.elements)) {
      this.elements.merge(initData.elements);
      // we don't want to go through all elements unless they are added.
      if (this.mapNavigationModel.items.length > 0) {
        this.elements.forEach((element, key) => {
          if (isDefined(element.visible)) {
            if (element.visible) {
              this.mapNavigationModel.show(key);
            } else {
              this.mapNavigationModel.hide(key);
            }
          }
        });
      }
    }

    // Add stories
    if (Array.isArray(initData.stories)) {
      this.stories = initData.stories;
      this.storyPromptShown++;
    }

    // Add map settings
    if (isJsonString(initData.viewerMode)) {
      const viewerMode = initData.viewerMode.toLowerCase();
      if (isViewerMode(viewerMode)) {
        setViewerMode(viewerMode, this.mainViewer);
      }
    }
    if (isJsonObject(initData.baseMaps)) {
      this.baseMapsModel.loadFromJson(CommonStrata.definition, initData.baseMaps).pushErrorTo(errors, "Failed to load basemaps");
    }
    if (isJsonObject(initData.homeCamera)) {
      this.loadHomeCamera(initData.homeCamera);
    }
    if (isJsonObject(initData.initialCamera)) {
      // When initialCamera is set:
      // - try to construct a CameraView and zoom to it
      // - otherwise, if `initialCamera.focusWorkbenchItems` is `true` flag it
      //   so that we can zoom after the workbench items are loaded.
      // - If there are multiple initSources, the setting from the last source takes effect
      try {
        const initialCamera = CameraView.fromJson(initData.initialCamera);
        this.currentViewer.zoomTo(initialCamera, 2.0);
        // reset in case this was enabled by a previous initSource
        this.focusWorkbenchItemsAfterLoadingInitSources = false;
      } catch (error) {
        // Not a CameraView but does it specify focusWorkbenchItems?
        if (typeof initData.initialCamera.focusWorkbenchItems === "boolean") {
          this.focusWorkbenchItemsAfterLoadingInitSources = initData.initialCamera.focusWorkbenchItems;
        } else {
          throw error;
        }
      }
    }
    if (isJsonBoolean(initData.showSplitter)) {
      this.showSplitter = initData.showSplitter;
    }
    if (isJsonNumber(initData.splitPosition)) {
      this.splitPosition = initData.splitPosition;
    }
    if (isJsonObject(initData.settings)) {
      if (isJsonNumber(initData.settings.baseMaximumScreenSpaceError)) {
        this.setBaseMaximumScreenSpaceError(initData.settings.baseMaximumScreenSpaceError);
      }
      if (isJsonBoolean(initData.settings.useNativeResolution)) {
        this.setUseNativeResolution(initData.settings.useNativeResolution);
      }
      if (isJsonBoolean(initData.settings.alwaysShowTimeline)) {
        this.timelineStack.setAlwaysShowTimeline(initData.settings.alwaysShowTimeline);
      }
      if (isJsonString(initData.settings.baseMapId)) {
        var _this$baseMapsModel$b3;
        baseMapPromise = this.mainViewer.setBaseMap((_this$baseMapsModel$b3 = this.baseMapsModel.baseMapItems.find(item => item.item.uniqueId === initData.settings.baseMapId)) === null || _this$baseMapsModel$b3 === void 0 ? void 0 : _this$baseMapsModel$b3.item);
      }
      if (isJsonNumber(initData.settings.terrainSplitDirection)) {
        this.terrainSplitDirection = initData.settings.terrainSplitDirection;
      }
      if (isJsonBoolean(initData.settings.depthTestAgainstTerrainEnabled)) {
        this.depthTestAgainstTerrainEnabled = initData.settings.depthTestAgainstTerrainEnabled;
      }
    }

    // Copy but don't yet load the workbench.
    const workbench = Array.isArray(initData.workbench) ? initData.workbench.slice() : [];
    const timeline = Array.isArray(initData.timeline) ? initData.timeline.slice() : [];

    // NOTE: after this Promise, this function is no longer an `@action`
    const models = initData.models;
    if (isJsonObject(models, false)) {
      await Promise.all(Object.keys(models).map(async modelId => {
        (await this.loadModelStratum(modelId, stratumId, models, replaceStratum)).pushErrorTo(errors);
      }));
    }
    runInAction(() => {
      if (isJsonString(initData.previewedItemId)) {
        this._previewedItemId = initData.previewedItemId;
      }
    });

    // Set the new contents of the workbench.
    const newItemsRaw = filterOutUndefined(workbench.map(modelId => {
      if (typeof modelId !== "string") {
        errors.push(new TerriaError({
          sender: this,
          title: "Invalid model ID in workbench",
          message: "A model ID in the workbench list is not a string."
        }));
      } else {
        return this.getModelByIdOrShareKey(BaseModel, modelId);
      }
    }));
    const newItems = [];

    // Maintain the model order in the workbench.
    for (;;) {
      const model = newItemsRaw.shift();
      if (model) {
        await this.pushAndLoadMapItems(model, newItems, errors);
      } else {
        break;
      }
    }
    newItems.forEach(item => {
      var _this$analytics3;
      // fire the google analytics event
      (_this$analytics3 = this.analytics) === null || _this$analytics3 === void 0 || _this$analytics3.logEvent(Category.dataSource, DataSourceAction.addFromShareOrInit, getPath(item));
    });
    runInAction(() => this.workbench.items = newItems);

    // For ids that don't correspond to models resolve an id by share keys
    const timelineWithShareKeysResolved = new Set(filterOutUndefined(timeline.map(modelId => {
      if (typeof modelId !== "string") {
        errors.push(new TerriaError({
          sender: this,
          title: "Invalid model ID in timeline",
          message: "A model ID in the timneline list is not a string."
        }));
      } else {
        if (this.getModelById(BaseModel, modelId) !== undefined) {
          return modelId;
        } else {
          return this.getModelIdByShareKey(modelId);
        }
      }
    })));

    // TODO: the timelineStack should be populated from the `timeline` property,
    // not from the workbench.
    runInAction(() => this.timelineStack.items = this.workbench.items.filter(item => {
      return item.uniqueId && timelineWithShareKeysResolved.has(item.uniqueId);
      // && TODO: what is a good way to test if an item is of type TimeVarying.
    }).map(item => item));
    if (isJsonObject(initData.pickedFeatures)) {
      when(() => !(this.currentViewer instanceof NoViewer)).then(() => {
        if (isJsonObject(initData.pickedFeatures)) {
          this.loadPickedFeatures(initData.pickedFeatures);
        }
      });
    } else if (canUnsetFeaturePickingState) {
      runInAction(() => {
        this.pickedFeatures = undefined;
        this.selectedFeature = undefined;
      });
    }
    if (((_initData$settings = initData.settings) === null || _initData$settings === void 0 ? void 0 : _initData$settings.shortenShareUrls) !== undefined) {
      this.setLocalProperty("shortenShareUrls", initData.settings.shortenShareUrls);
    }
    if (errors.length > 0) throw TerriaError.combine(errors, {
      message: {
        key: "models.terria.loadingInitSourceErrorTitle"
      }
    });
    return {
      baseMapPromise
    };
  }
  loadHomeCamera(homeCameraInit) {
    this.mainViewer.homeCamera = CameraView.fromJson(homeCameraInit);
  }

  /**
   * This method can be used to refresh magda based catalogue configuration. Useful if the catalogue
   * has items that are only available to authorised users.
   *
   * @param magdaCatalogConfigUrl URL of magda based catalogue configuration
   * @param config Optional. If present, use this magda based catalogue config instead of reloading.
   * @param configUrlHeaders  Optional. If present, the headers are added to above URL request.
   */
  async refreshCatalogMembersFromMagda(magdaCatalogConfigUrl, config, configUrlHeaders) {
    const theConfig = config ? config : await loadJson5(magdaCatalogConfigUrl, configUrlHeaders);

    // force config (root group) id to be `/`
    const id = "/";
    this.removeModelReferences(this.catalog.group);
    let existingReference = this.getModelById(MagdaReference, id);
    if (existingReference === undefined) {
      var _theConfig$aspects;
      existingReference = new MagdaReference(id, this);
      // Add model with terria aspects shareKeys
      this.addModel(existingReference, (_theConfig$aspects = theConfig.aspects) === null || _theConfig$aspects === void 0 || (_theConfig$aspects = _theConfig$aspects.terria) === null || _theConfig$aspects === void 0 ? void 0 : _theConfig$aspects.shareKeys);
    }
    const reference = existingReference;
    const magdaRoot = new URI(magdaCatalogConfigUrl).path("").query("").toString();
    reference.setTrait(CommonStrata.definition, "url", magdaRoot);
    reference.setTrait(CommonStrata.definition, "recordId", id);
    reference.setTrait(CommonStrata.definition, "magdaRecord", theConfig);
    (await reference.loadReference(true)).raiseError(this, "Failed to load MagdaReference for record ".concat(id));
    if (reference.target instanceof CatalogGroup) {
      runInAction(() => {
        this.catalog.group.dispose();
        this.catalog.group = reference.target;
      });
    }
  }
  async loadMagdaConfig(configUrl, config, baseUri) {
    var _aspects$terriaConfi, _config$aspects, _config$aspects2;
    const aspects = config.aspects;
    const configParams = (_aspects$terriaConfi = aspects["terria-config"]) === null || _aspects$terriaConfi === void 0 ? void 0 : _aspects$terriaConfi.parameters;
    if (configParams) {
      this.updateParameters(configParams);
    }
    const initObj = aspects["terria-init"];
    if (isJsonObject(initObj)) {
      const {
          catalog
        } = initObj,
        initObjWithoutCatalog = _objectWithoutProperties(initObj, _excluded);
      /** Load the init data without the catalog yet, as we'll push the catalog
       * source up as an init source later */
      try {
        await this.applyInitData({
          initData: initObjWithoutCatalog
        });
      } catch (e) {
        this.raiseErrorToUser(e, {
          title: {
            key: "models.terria.loadingMagdaInitSourceErrorMessage"
          },
          message: {
            key: "models.terria.loadingMagdaInitSourceErrorMessage",
            parameters: {
              url: configUrl
            }
          }
        });
      }
    }
    if (aspects.group && aspects.group.members) {
      await this.refreshCatalogMembersFromMagda(configUrl, config);
    }
    this.setupInitializationUrls(baseUri, (_config$aspects = config.aspects) === null || _config$aspects === void 0 ? void 0 : _config$aspects["terria-config"]);
    /** Load up rest of terria catalog if one is inlined in terria-init */
    if ((_config$aspects2 = config.aspects) !== null && _config$aspects2 !== void 0 && _config$aspects2["terria-init"]) {
      const {
        catalog
      } = initObj;
      this.initSources.push({
        name: "Magda map-config aspect terria-init from ".concat(configUrl),
        errorSeverity: TerriaErrorSeverity.Error,
        data: {
          catalog: catalog
        }
      });
    }
  }
  async loadPickedFeatures(pickedFeatures) {
    var _this$pickedFeatures;
    let vectorFeatures = [];
    const featureIndex = {};
    if (Array.isArray(pickedFeatures.entities)) {
      // Build index of terria features by a hash of their properties.
      const relevantItems = this.workbench.items.filter(item => hasTraits(item, MappableTraits, "show") && item.show && MappableMixin.isMixedInto(item));
      relevantItems.forEach(item => {
        const entities = item.mapItems.filter(isDataSource).reduce((arr, ds) => arr.concat(ds.entities.values), []);
        entities.forEach(entity => {
          const feature = TerriaFeature.fromEntityCollectionOrEntity(entity);
          const hash = hashEntity(feature, this);
          featureIndex[hash] = (featureIndex[hash] || []).concat([feature]);
        });
      });

      // Go through the features we've got from terria match them up to the id/name info we got from the
      // share link, filtering out any without a match.
      vectorFeatures = filterOutUndefined(pickedFeatures.entities.map(e => {
        if (isJsonObject(e) && typeof e.hash === "number") {
          const features = featureIndex[e.hash] || [];
          const match = features.find(f => f.name === e.name);
          return match;
        }
      }));
    }

    // Set the current pick location, if we have a valid coord
    const maybeCoords = pickedFeatures.pickCoords;
    const pickCoords = {
      latitude: maybeCoords === null || maybeCoords === void 0 ? void 0 : maybeCoords.lat,
      longitude: maybeCoords === null || maybeCoords === void 0 ? void 0 : maybeCoords.lng,
      height: maybeCoords === null || maybeCoords === void 0 ? void 0 : maybeCoords.height
    };
    if (isLatLonHeight(pickCoords) && isProviderCoordsMap(pickedFeatures.providerCoords)) {
      this.currentViewer.pickFromLocation(pickCoords, pickedFeatures.providerCoords, vectorFeatures);
    }
    if ((_this$pickedFeatures = this.pickedFeatures) !== null && _this$pickedFeatures !== void 0 && _this$pickedFeatures.allFeaturesAvailablePromise) {
      var _this$pickedFeatures2;
      // When feature picking is done, set the selected feature
      await ((_this$pickedFeatures2 = this.pickedFeatures) === null || _this$pickedFeatures2 === void 0 ? void 0 : _this$pickedFeatures2.allFeaturesAvailablePromise);
    }
    runInAction(() => {
      var _this$pickedFeatures3;
      (_this$pickedFeatures3 = this.pickedFeatures) === null || _this$pickedFeatures3 === void 0 || _this$pickedFeatures3.features.forEach(feature => {
        const hash = hashEntity(feature, this);
        featureIndex[hash] = (featureIndex[hash] || []).concat([feature]);
      });

      // Find picked feature by matching feature hash
      // Also try to match name if defined
      const current = pickedFeatures.current;
      if (isJsonObject(current) && typeof current.hash === "number") {
        var _find, _featureIndex$current;
        const selectedFeature = (_find = (featureIndex[current.hash] || []).find(feature => feature.name === current.name)) !== null && _find !== void 0 ? _find : (_featureIndex$current = featureIndex[current.hash]) === null || _featureIndex$current === void 0 ? void 0 : _featureIndex$current[0];
        if (selectedFeature) {
          this.selectedFeature = selectedFeature;
        }
      }
    });
  }
  async initCorsProxy(config, serverConfig) {
    if (config.proxyableDomainsUrl) {
      console.warn(i18next.t("models.terria.proxyableDomainsDeprecation"));
    }
    this.corsProxy.init(serverConfig, this.configParameters.corsProxyBaseUrl, []);
  }
  getLocalProperty(key) {
    try {
      if (!defined(window.localStorage)) {
        return null;
      }
    } catch (_e) {
      // SecurityError can arise if 3rd party cookies are blocked in Chrome and we're served in an iFrame
      return null;
    }
    const v = window.localStorage.getItem(this.appName + "." + key);
    if (v === "true") {
      return true;
    } else if (v === "false") {
      return false;
    }
    return v;
  }
  setLocalProperty(key, value) {
    try {
      if (!defined(window.localStorage)) {
        return false;
      }
    } catch (_e) {
      return false;
    }
    window.localStorage.setItem(this.appName + "." + key, value.toString());
    return true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "mainViewer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new TerriaViewer(this, computed(() => filterOutUndefined(this.overlays.items.map(item => MappableMixin.isMixedInto(item) ? item : undefined).concat(this.workbench.items.map(item => MappableMixin.isMixedInto(item) ? item : undefined)))));
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "configParameters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      appName: "TerriaJS App",
      supportEmail: "info@terria.io",
      defaultMaximumShownFeatureInfos: 100,
      catalogIndexUrl: undefined,
      regionMappingDefinitionsUrl: undefined,
      regionMappingDefinitionsUrls: ["build/TerriaJS/data/regionMapping.json"],
      proj4ServiceBaseUrl: "proj4def/",
      corsProxyBaseUrl: "proxy/",
      proxyableDomainsUrl: "proxyabledomains/",
      // deprecated, will be determined from serverconfig
      serverConfigUrl: "serverconfig/",
      shareUrl: "share",
      feedbackUrl: undefined,
      initFragmentPaths: ["init/"],
      storyEnabled: true,
      showStorySaveInstructions: false,
      interceptBrowserPrint: true,
      tabbedCatalog: false,
      useCesiumIonTerrain: true,
      cesiumTerrainUrl: undefined,
      cesiumTerrainAssetId: undefined,
      cesiumIonAccessToken: undefined,
      useCesiumIonBingImagery: undefined,
      cesiumIonOAuth2ApplicationID: undefined,
      cesiumIonLoginTokenPersistence: "page",
      cesiumIonAllowSharingAddedAssets: false,
      bingMapsKey: undefined,
      hideTerriaLogo: false,
      brandBarElements: undefined,
      brandBarSmallElements: undefined,
      displayOneBrand: 0,
      disableMyLocation: undefined,
      disableSplitter: undefined,
      disablePedestrianMode: false,
      keepCatalogOpen: false,
      experimentalFeatures: undefined,
      magdaReferenceHeaders: undefined,
      locationSearchBoundingBox: undefined,
      googleAnalyticsKey: undefined,
      errorService: undefined,
      globalDisclaimer: undefined,
      theme: {},
      showWelcomeMessage: false,
      welcomeMessageVideo: {
        videoTitle: "Getting started with the map",
        videoUrl: "https://www.youtube-nocookie.com/embed/FjSxaviSLhc",
        placeholderImage: "https://img.youtube.com/vi/FjSxaviSLhc/maxresdefault.jpg"
      },
      storyVideo: {
        videoUrl: "https://www.youtube-nocookie.com/embed/fbiQawV8IYY"
      },
      showInAppGuides: false,
      helpContent: [],
      helpContentTerms: defaultTerms,
      languageConfiguration: undefined,
      customRequestSchedulerLimits: undefined,
      persistViewerMode: true,
      openAddData: false,
      feedbackPreamble: "translate#feedback.feedbackPreamble",
      feedbackPostamble: undefined,
      feedbackMinLength: 0,
      leafletMaxZoom: 18,
      leafletAttributionPrefix: undefined,
      extraCreditLinks: [
      // Default credit links (shown at the bottom of the Cesium map)
      {
        text: "map.extraCreditLinks.dataAttribution",
        url: "https://terria.io/attributions"
      }, {
        text: "map.extraCreditLinks.termsOfUse",
        url: "https://terria.io/demo-terms"
      }],
      printDisclaimer: undefined,
      storyRouteUrlPrefix: undefined,
      enableConsoleAnalytics: undefined,
      googleAnalyticsOptions: undefined,
      relatedMaps: [],
      aboutButtonHrefUrl: "about.html",
      plugins: undefined,
      searchBarConfig: undefined,
      searchProviders: []
    };
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "pickedFeatures", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedFeature", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "allowFeatureInfoRequests", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "mapInteractionModeStack", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isWorkflowPanelActive", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectableDimensionWorkflow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "baseMapContrastColor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "baseMapContrastColor"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userProperties", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "initSources", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "serverConfig", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "shareDataService", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "showSplitter", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "splitPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.5;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "splitPositionVertical", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.5;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "terrainSplitDirection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return SplitDirection.NONE;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "depthTestAgainstTerrainEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "stories", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "storyPromptShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_previewedItemId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "baseMaximumScreenSpaceError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 2;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "mapNavigationModel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new MapNavigationModel(this);
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "useNativeResolution", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "catalogReferencesLoaded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "currentViewer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentViewer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cesium", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cesium"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "terrainProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "terrainProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "leaflet", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "leaflet"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modelValues", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "modelValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "modelIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "modelIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addModel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeModelReferences", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeModelReferences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeSelectedFeaturesForModel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeSelectedFeaturesForModel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addShareKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addShareKey"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUseNativeResolution", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUseNativeResolution"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setBaseMaximumScreenSpaceError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setBaseMaximumScreenSpaceError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateParameters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateParameters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_applyInitData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_applyInitData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadHomeCamera", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadHomeCamera"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadPickedFeatures", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPickedFeatures"), _class.prototype), _class);
export { Terria as default };
function generateInitializationUrl(baseUri, initFragmentPaths, url) {
  if (url.toLowerCase().substring(url.length - 5) !== ".json") {
    return {
      options: initFragmentPaths.map(fragmentPath => {
        return {
          initUrl: new URI(fragmentPath).segment(url).suffix("json").absoluteTo(baseUri).toString()
        };
      })
    };
  }
  return {
    initUrl: new URI(url).absoluteTo(baseUri).toString()
  };
}
async function interpretHash(terria, hashProperties, userProperties, baseUri) {
  if (isDefined(hashProperties.clean)) {
    runInAction(() => {
      terria.initSources.splice(0, terria.initSources.length);
    });
  }
  runInAction(() => {
    Object.keys(hashProperties).forEach(function (property) {
      if (["clean", "hideWelcomeMessage", "start", "share"].includes(property)) return;
      const propertyValue = hashProperties[property];
      if (defined(propertyValue) && propertyValue.length > 0) {
        userProperties.set(property, propertyValue);
      } else {
        const initSourceFile = generateInitializationUrl(baseUri, terria.configParameters.initFragmentPaths, property);
        terria.initSources.push(_objectSpread({
          name: "InitUrl from applicationURL hash ".concat(property),
          errorSeverity: TerriaErrorSeverity.Error
        }, initSourceFile));
      }
    });
  });
  if (isDefined(hashProperties.hideWelcomeMessage)) {
    terria.configParameters.showWelcomeMessage = false;
  }

  // a share link that hasn't been shortened: JSON embedded in URL (only works for small quantities of JSON)
  if (isDefined(hashProperties.start)) {
    try {
      const startData = JSON.parse(hashProperties.start);
      await interpretStartData(terria, startData, 'Start data from hash `"#start"` value', TerriaErrorSeverity.Error, false // Hide conversion warning message - as we assume that people using #start are embedding terria.
      );
    } catch (e) {
      throw TerriaError.from(e, {
        message: {
          key: "models.terria.parsingStartDataErrorMessage"
        },
        importance: -1
      });
    }
  }

  // Resolve #share=xyz with the share data service.
  if (hashProperties.share !== undefined && terria.shareDataService !== undefined) {
    const shareProps = await terria.shareDataService.resolveData(hashProperties.share);
    await interpretStartData(terria, shareProps, "Start data from sharelink `\"".concat(hashProperties.share, "\"`"));
  }
}
async function interpretStartData(terria, startData, /** Name for startData initSources - this is only used for debugging purposes */
name, /** Error severity to use for loading startData init sources - if not set, TerriaError will be propagated normally */
errorSeverity) {
  let showConversionWarning = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  if (isJsonObject(startData, false)) {
    // Convert startData to v8 if necessary
    let startDataV8;
    try {
      if (
      // If startData.version has version 0.x.x - user catalog-converter to convert startData
      "version" in startData && typeof startData.version === "string" && startData.version.startsWith("0")) {
        const {
          convertShare
        } = await import("catalog-converter");
        const result = convertShare(startData);

        // Show warning messages if converted
        if (result.converted && showConversionWarning) {
          terria.notificationState.addNotificationToQueue({
            title: i18next.t("share.convertNotificationTitle"),
            message: shareConvertNotification(result.messages)
          });
        }
        startDataV8 = result.result;
      } else {
        startDataV8 = _objectSpread(_objectSpread({}, startData), {}, {
          version: isJsonString(startData.version) ? startData.version : SHARE_VERSION,
          initSources: Array.isArray(startData.initSources) ? startData.initSources.filter(initSource => isJsonString(initSource) || isJsonObject(initSource)) : []
        });
      }
      if (startDataV8 !== null && Array.isArray(startDataV8.initSources)) {
        // Push startData.initSources to terria.initSources array
        // Note startData.initSources can be an initUrl (string) or initData (InitDataSource/JsonObject)
        // Terria.initSources are different to startData.initSources
        // They need to be transformed into appropriate `InitSource`
        runInAction(() => {
          terria.initSources.push(...startDataV8.initSources.map(initSource => isJsonString(initSource) ?
          // InitSourceFromUrl if string
          {
            name,
            initUrl: initSource,
            errorSeverity
          } :
          // InitSourceFromData if Json Object
          {
            name,
            data: initSource,
            errorSeverity
          }));
        });

        // If initSources contain story - we disable the welcome message so there aren't too many modals/popups
        // We only check JSON share initSources - as URLs will be loaded in `forceLoadInitSources`
        if (startDataV8.initSources.some(initSource => isJsonObject(initSource) && Array.isArray(initSource.stories) && initSource.stories.length)) {
          terria.configParameters.showWelcomeMessage = false;
        }
      }
    } catch (error) {
      throw TerriaError.from(error, {
        title: {
          key: "share.convertErrorTitle"
        },
        message: {
          key: "share.convertErrorMessage"
        }
      });
    }
  }
}
function setCustomRequestSchedulerDomainLimits(customDomainLimits) {
  if (isDefined(customDomainLimits)) {
    Object.entries(customDomainLimits).forEach(_ref => {
      let [domain, limit] = _ref;
      RequestScheduler.requestsByServer[domain] = limit;
    });
  }
}